import { configurationSchema } from '@e-kyc/configuration';

export const configuration = configurationSchema.parse({
  mode: import.meta.env.MODE,
  logLevel: import.meta.env.VITE_LOG_LEVEL,
  showConsole: import.meta.env.VITE_SHOW_CONSOLE === 'true',
  termsAndConditions: {
    url: {
      th: import.meta.env.VITE_TERMS_AND_CONDITIONS_URL_TH,
      en: import.meta.env.VITE_TERMS_AND_CONDITIONS_URL_EN,
    },
  },
  graphql: {
    apiUrl: import.meta.env.VITE_GRAPHQL_API_URL,
  },
});
